import {Component, ErrorHandler, OnInit} from '@angular/core';
import {NavigationError, Router} from '@angular/router';
import {filter} from 'rxjs';
import {Auth2Service} from './auth/auth2.service';
import {isChunkLoadError} from './mir-http-error-handler';
import {Angulartics2GoogleAnalytics} from "angulartics2";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private auth2Service: Auth2Service,
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private router: Router,
    private errorHandler: ErrorHandler,
  ) {
    this.angulartics2GoogleAnalytics.startTracking();

  }

  ngOnInit(): void {
    this.auth2Service.loadUser();

    // Quand le chargement d'un module de route échoue, le routeur absorbe
    // l'erreur et publie un NavigationError : elle n'atteint pas forcément le
    // ErrorHandler global. On ne lui transmet QUE ce cas-là, pour qu'une page
    // devenue périmée après un déploiement soit rechargée au lieu
    // d'immobiliser le menu sans un mot (voir
    // MirHttpErrorHandler.reloadForNewVersion). Les autres échecs de
    // navigation gardent leur comportement actuel.
    this.router.events
      .pipe(filter((event): event is NavigationError => event instanceof NavigationError))
      .subscribe(event => {
        if (isChunkLoadError(event.error)) {
          this.errorHandler.handleError(event.error);
        }
      });
  }
}
